import { render, staticRenderFns } from "./ChooseOrgTree.vue?vue&type=template&id=1728b300&scoped=true"
import script from "./ChooseOrgTree.vue?vue&type=script&lang=js"
export * from "./ChooseOrgTree.vue?vue&type=script&lang=js"
import style0 from "./ChooseOrgTree.vue?vue&type=style&index=0&id=1728b300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1728b300",
  null
  
)

export default component.exports